export default function useCpfValidation() {
  const validateCpfAlgorithm = (cpf) => {
    // Remove formatting
    const cleanCpf = cpf.replace(/\D/g, "");

    // Check length
    if (cleanCpf.length !== 11) {
      return false;
    }

    // Check for invalid patterns (all same digit)
    if (/^(\d)\1{10}$/.test(cleanCpf)) {
      return false;
    }

    // Validate first check digit
    let sum = 0;
    for (let i = 0; i < 9; i += 1) {
      sum += parseInt(cleanCpf[i], 10) * (10 - i);
    }
    let remainder = sum % 11;
    const digit1 = remainder < 2 ? 0 : 11 - remainder;

    if (parseInt(cleanCpf[9], 10) !== digit1) {
      return false;
    }

    // Validate second check digit
    sum = 0;
    for (let i = 0; i < 10; i += 1) {
      sum += parseInt(cleanCpf[i], 10) * (11 - i);
    }
    remainder = sum % 11;
    const digit2 = remainder < 2 ? 0 : 11 - remainder;

    return parseInt(cleanCpf[10], 10) === digit2;
  };

  const getCpfErrorMessage = (cpf) => {
    if (!cpf || cpf.replace(/\D/g, "").length === 0) {
      return null;
    }

    const cleanCpf = cpf.replace(/\D/g, "");

    if (cleanCpf.length !== 11) {
      return "CPF deve conter 11 dígitos";
    }

    if (!validateCpfAlgorithm(cpf)) {
      return "CPF inválido";
    }

    return null;
  };

  return {
    validateCpfAlgorithm,
    getCpfErrorMessage,
  };
}
